import { render, staticRenderFns } from "./userEmployeeDoctor.vue?vue&type=template&id=81bf6230&"
import script from "./userEmployeeDoctor.vue?vue&type=script&lang=js&"
export * from "./userEmployeeDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports